import { Row } from '@tanstack/react-table';
import { useFormContext, useWatch } from 'react-hook-form';

import { parseFormNumber } from '@/helpers/finance';

import { getBillFieldName } from '../../components/generate-bills-table/bill-row.helpers';
import { GenerateBillListItem } from '../../types';

/**
 * A selected sub-row with BOTH hours and rate at zero would bill nothing, which is almost
 * always a mistake. Used to flag the field and to disable the Generate button.
 */
export const useHasZeroAmountError = (row: Row<GenerateBillListItem>): boolean => {
  const { control } = useFormContext();

  const hours = useWatch({ control, name: getBillFieldName(row, 'hours') });
  const rate = useWatch({ control, name: getBillFieldName(row, 'effectiveRate') });

  return row.getIsSelected() && parseFormNumber(hours) === 0 && parseFormNumber(rate) === 0;
};
